import { faWhatsapp } from "@fortawesome/free-brands-svg-icons/faWhatsapp";
import { faPen } from "@fortawesome/free-solid-svg-icons/faPen";
import { Progress, Tooltip } from "../../../../utils/local-antd";
import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";

import { Button } from "../../../../components/Button";
import { Flex } from "../../../../components/Flex";
import { Text } from "../../../../components/Text";
import { integrationSliceSelectors } from "../../../../redux/integration/integration.selector";
import { useAppSelector } from "../../../../redux/store";
import { ThemeType } from "../../../../theme/Theme";
import { useIntegrationContext } from "../../context/integration-context";
import { IntegrationSection } from "../IntegrationSection";

const getProgressColor = (percent: number): keyof ThemeType => {
  switch (true) {
    case percent < 25:
      return "danger";
    case percent >= 25 && percent < 50:
      return "warning";
    case percent >= 50 && percent < 75:
      return "caution";
    case percent >= 75 && percent < 100:
      return "positive";
    case percent === 100:
      return "success";

    default:
      return "danger";
  }
};

const StyledProgress = styled(Progress)`
  .ant-progress-inner {
    width: 2.5rem !important;
    height: 2.5rem !important;
    font-size: 0.8rem !important;
  }
  .ant-progress-circle-path {
    stroke: ${({ percent, theme }) =>
      percent ? theme[getProgressColor(percent)] : theme.main} !important;
  }
`;

const SpanWithUnderline = styled.span`
  border-bottom: ${({ theme }) => `1px solid ${theme.darkerSub}`};
`;

const StyledButton = styled(Button)`
  background-color: transparent;
  padding: 0;
  color: ${({ theme }) => theme.main};
  margin-inline-start: auto;
`;

export const IntegrationWhatsAppSection: React.FC = () => {
  const { setAddModalWhatsAppVisible } = useIntegrationContext();
  const { t } = useTranslation();

  const integration = useAppSelector(
    integrationSliceSelectors.selectWhatsAppIntegration,
  );
  const isEnabled = integration?.status.enabled;

  if (!integration) {
    return null;
  }

  return (
    <IntegrationSection
      enabled={isEnabled}
      icon={faWhatsapp}
      iconColor="whatsapp"
    >
      <Flex gap="s" alignItems="center" flex={1}>
        <Flex marginInlineStart="auto">
          <Text color="darkerSub">
            <Trans
              i18nKey="integration.integration.registeredWith"
              values={{ registeredWith: integration.config.phoneNumber }}
              components={[<SpanWithUnderline />]}
            />
          </Text>
        </Flex>

        <Flex alignItems="center" gap="s" marginInlineStart="auto">
          <Text>{t("integration.integration.completed")} </Text>
          <StyledProgress type="circle" percent={75} />
        </Flex>

        <Tooltip title={t("common.edit")}>
          <StyledButton
            icon={faPen}
            onClick={() => setAddModalWhatsAppVisible(true)}
            iconWidth="xl"
          />
        </Tooltip>
      </Flex>
    </IntegrationSection>
  );
};
